import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { Spacing } from '../../styles';
import { Colors } from '../../themes';
import { RightButton } from './leftRightButtons';

type SaveButtonProps = {
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  label?: string;
  isLoading?: boolean;
  activeTextColor?: string;
  fontSize?: number;
};

export const SaveButton: FC<SaveButtonProps> = (props: SaveButtonProps) => {
  const { t } = useTranslation();

  return (
    <RightButton
      testID="save-button"
      onPress={props.onPress}
      label={props.label ? props.label : t('topNav.save')}
      disabled={props.disabled}
      color={Colors.white}
      hideCaret={true}
      isLoading={props.isLoading}
      style={props.style ? props.style : styles.right}
      fontSize={props.fontSize}
    />
  );
};

const styles = StyleSheet.create({
  right: {
    marginRight: Spacing.baseMargin.base,
  },
});
